import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, DotLegalTableWithControls, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import useDocumentTypesHooks from "./DocumentTypes.hooks";
import { DocumentType } from "./DocumentTypes.types";
import { Box, TableCell, TableRow } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import AddEditDocumentTypeDialog from "../addEditDocumentTypeDialog/AddEditDocumentTypeDialog";
import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function DocumentTypes() {
    const {
        documentTypes,
        isLoading,
        breadCrumbs,
        getMenuItems,
        onDialogClose,
        showCreateDialog,
        onSaved,
        documentTypeForDeletion,
        setDocumentTypeForDeletion,
        onDelete,
        onCreateClick,
        canManageMasterData,
        documentTypeForUpdate,
        isDeleting,
    } = useDocumentTypesHooks();
    const { translateString, translateDocumentTypeUsage } = useTranslation();

    const headers = Array<ITableHeader<DocumentType>>();
    headers.push({ property: "name", text: translateString("name") });
    headers.push({ property: "isCustom", text: translateString("standardMasterData") });
    headers.push({ property: "usages", text: translateString("usageAreas") });

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={breadCrumbs}
                rightComponent={
                    canManageMasterData ? (
                        <DotLegalButton size="medium" buttonType={"primary"} onClick={() => onCreateClick()}>
                            {translateString("createDocumentType")}
                        </DotLegalButton>
                    ) : undefined
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControls
                    internalScroll
                    headers={headers}
                    isLoading={isLoading}
                    data={documentTypes}
                    emptyText={translateString("noDataTypes")}
                    defaultOrderBy={"name"}
                    hideRowsPerPage
                    getUserSpecificPageLength={() => 100}
                    labelRowsPerPage={translateString("showEntites")}
                    labelSearch={translateString("search")}
                    noOptionsLabel={translateString("noOptions")}
                    paginationLabelOf={translateString("labelOf")}
                    clickableRows={false}
                    hasOverflowMenu
                    renderRow={(row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                                <Box sx={{ height: "20px !important" }}>{!row.isCustom ? <CheckIcon sx={{ height: "20px !important" }} /> : ""}</Box>
                            </TableCell>
                            <TableCell>{row.usages.map((u) => translateDocumentTypeUsage(u.toString())).join(", ")}</TableCell>
                            <TableCell align={"right"}>{row.isCustom && <DotLegalOverflowMenu items={getMenuItems(row)} />}</TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>
            {documentTypeForDeletion && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => setDocumentTypeForDeletion(undefined)}
                    onOkClick={onDelete}
                    itemForDeletion={documentTypeForDeletion.name}
                    inProgress={isDeleting}
                />
            )}
            {(showCreateDialog || documentTypeForUpdate !== undefined) && (
                <AddEditDocumentTypeDialog
                    onDialogClose={onDialogClose}
                    isAdd={documentTypeForUpdate === undefined}
                    documentTypeToUpdate={documentTypeForUpdate}
                    onSaved={onSaved}
                />
            )}
        </Box>
    );
}

export default DocumentTypes;
